"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var colorUtil = require('../../util/color');

var _require = require('../../util/rect'),
    getRectByReactElement = _require.getRectByReactElement;

var template = require('./colorSpace.jsx');

var displayNames = require('../displayNames');

var hsbToStyle = function hsbToStyle(hsb) {
  return {
    left: "".concat(hsb.saturation, "%"),
    bottom: "calc(".concat(hsb.brightness, "% - 10px)"),
    borderColor: hsb.brightness > 60 ? '#000' : '#FFF'
  };
};

var isCloseOrEqual = function isCloseOrEqual(a, b) {
  return Math.abs(b - a) <= 5;
};

var ColorSpace = /*#__PURE__*/function (_React$Component) {
  _inherits(ColorSpace, _React$Component);

  var _super = _createSuper(ColorSpace);

  function ColorSpace(props) {
    var _this;

    _classCallCheck(this, ColorSpace);

    _this = _super.call(this, props);
    _this.state = {
      hsb: colorUtil.hexToHsb(_this.props.value)
    };

    _this.getMarkerPosition = function () {
      return hsbToStyle(_this.state.hsb);
    };

    var ensureWithinLimits = function ensureWithinLimits(n) {
      return Math.min(Math.max(0, n), 100);
    };

    var getHsbColorByMouseEvent = function getHsbColorByMouseEvent(e) {
      var x = e.clientX - _this.gradientRect.x;
      var y = e.clientY - _this.gradientRect.y;
      var saturation = ensureWithinLimits(100 * x / _this.gradientRect.width);
      var brightness = ensureWithinLimits(100 - 100 * y / _this.gradientRect.height);
      var hue = _this.state.hsb.hue;
      return {
        brightness: brightness,
        saturation: saturation,
        hue: hue
      };
    };

    _this.setNewColorByMouseEvent = function (e) {
      var hsb = getHsbColorByMouseEvent(e);
      var newColor = colorUtil.hsbToHex(hsb);

      if (hsb.brightness < 5) {
        _this.setState({
          hsb: hsb
        }, function () {
          _this.props.onChange(newColor);
        });
      } else {
        _this.props.onChange(newColor);
      }
    };

    _this.onMarkerDragStart = function (e) {
      window.addEventListener('mousemove', _this.onMarkerDrag);
      window.addEventListener('mouseup', _this.onMarkerDragEnd);
      _this.gradientRect = getRectByReactElement(_this.refs.gradient);

      _this.setNewColorByMouseEvent(e);
    };

    _this.onMarkerDrag = function (e) {
      _this.setNewColorByMouseEvent(e);
    };

    _this.onMarkerDragEnd = function () {
      window.removeEventListener('mousemove', _this.onMarkerDrag);
      window.removeEventListener('mouseup', _this.onMarkerDragEnd);
    };

    _this.setNewColorByHue = function (hue) {
      return _({
        hue: hue
      }).defaults(_this.state.hsb).thru(colorUtil.hsbToHex).thru(function (hex) {
        _this.setState({
          hsb: _.defaults({
            hue: hue
          }, _this.state.hsb)
        }, function () {
          _this.props.onChange(hex);
        });
      }).value();
    };

    _this.getBrightnessOptions = function () {
      return _(5).times(function () {
        return _this.state.hsb;
      }).map(function (color, i) {
        return colorUtil.hsbToHex({
          hue: _this.state.hsb.hue,
          saturation: color.saturation,
          brightness: i * 20 + 10
        });
      }).reverse();
    };

    _this.setNewColorByHex = function (hex) {
      return _this.props.onChange(hex);
    };

    return _this;
  }

  _createClass(ColorSpace, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var hsb = colorUtil.hexToHsb(nextProps.value);
      var shouldKeepHue = hsb.saturation < 5 || hsb.brightness < 5 || isCloseOrEqual(hsb.hue % 358, this.state.hsb.hue % 358);
      var shouldKeepSaturation = hsb.brightness < 5;
      this.setState({
        hsb: _.defaults({
          hue: shouldKeepHue ? this.state.hsb.hue : hsb.hue,
          saturation: shouldKeepSaturation ? this.state.hsb.saturation : hsb.saturation
        }, hsb)
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.onMarkerDrag);
      window.removeEventListener('mouseup', this.onMarkerDragEnd);
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return ColorSpace;
}(React.Component);

ColorSpace.displayName = displayNames.COLOR_SPACE;
ColorSpace.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
ColorSpace.defaultProps = {};
module.exports = compose(ColorSpace);